import * as yup from 'yup';
import { FormModal } from 'components/form/FormModal/FormModal';
import { FormInputGroup, FormText } from 'components/form';
import { DefaultOpenModalProps } from 'components/button/OpenModalButton/OpenModalButton';

interface DefaultConfirmEmail {
    email: string;
}

const defaultValues: DefaultConfirmEmail = {
    email: '',
};

export interface ConfirmEmailDialogProps extends DefaultOpenModalProps {
    onSubmitEmail: React.Dispatch<React.SetStateAction<string>>;
}

export const ConfirmEmailDialog = ({
    modalOpen,
    setModalOpen,
    onSubmitEmail,
}: ConfirmEmailDialogProps) => {
    const confirmEmailSchema = yup.object({
        email: yup.string().email().required(),
    });

    const onSubmit = (data: DefaultConfirmEmail) => {
        setModalOpen(false);
        onSubmitEmail(data.email);
    };

    return (
        <FormModal
            validationSchema={confirmEmailSchema}
            defaultValues={defaultValues}
            title="Please confirm your email"
            modalOpen={modalOpen}
            setModalOpen={setModalOpen}
            onValidHandler={onSubmit}
            onErrorHandler={(error) => error}
            testId="ConfirmEmailDialog"
            maxWidth="xs"
        >
            <FormInputGroup>
                <FormText field="email" label="Email" />
            </FormInputGroup>
        </FormModal>
    );
};
